<template>
  <div class="extras-component pt-3 pt-md-5 py-5" ref="wrapper">

    <div class="d-none d-md-flex justify-content-between header mb-3 align-items-center">
      <h2 class="d-flex align-items-center">
        <i class="fak fa-customise me-4"></i>
        <span class="me-2">Choose</span> Your Extras
      </h2>
      <h3 v-if="activeScreen" @click="vueBack" class="d-flex align-items-center cursor-pointer">
        <i class="fa fa-arrow-left me-4"></i>
        Go back
      </h3>
    </div>

    <div v-if="nonEmptyProductCategories.length > 0" class="choose-category-wrapper d-flex flex-column flex-md-row align-items-center justify-content-between rounded py-25 px-35 mb-3 mb-md-4">
      <h2 class="mt-2 mt-md-0 mb-2 mb-md-0 w-100">Choose the category of extras...</h2>

      <div class="select-wrapper position-relative form-floating w-100">
        <select v-model="selectedCategory" class="form-control" id="category-select">
          <option v-for="category in nonEmptyProductCategories" :value="category.id">{{ category.name }}</option>
        </select>

        <i class="far fa-chevron-down"></i>

        <label for="category-select">Category</label>
      </div>
    </div>

    <div v-if="nonEmptyProductCategories.length > 0">
      <div
        v-for="productCategory in nonEmptyProductCategories"
        :key="productCategory.id"
      >
        <div
          v-if="!products[productCategory.id] || Object.keys(products[productCategory.id]).length === 0"
          class="alert alert-warning"
        >
          No products are available in this category.
        </div>

        <div v-else class="row">
          <div
            v-for="product in products[productCategory.id]"
            :key="product.id"
            class="col-6 col-lg-4"
            :class="{ 'col-xxl-3': activeScreen }"
            v-show="selectedCategory === productCategory.id"
          >
            <div class="card mb-4">
              <div class="card-body text-dark d-flex flex-column align-items-center position-relative">
                <div class="d-flex justify-content-end">
                  <div
                    class="
                          icon-wrapper
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                    data-bs-toggle="tooltip"
                    data-placement="bottom"
                    :title="product.summary"
                  >
                    <i class="far fa-info-circle"></i>
                  </div>
                </div>

                <img :src="product.image_url" :alt="product.name" class="my-4"/>

                <h6>{{ product.name }}</h6>
                <h6 v-if="!hidePrices" class="price">
                  {{ product.type === "matrix" ? "from " : "" }}&pound;{{
                    product.price_inc_tax | money
                  }}
                </h6>
                <div class="btn-wrapper d-flex align-items-center justify-content-between p-md-3 mt-auto w-100">
                  <button
                    @click="removeItem(product, 1)"
                    class="
                          btn btn-secondary
                          d-none
                          align-items-center
                          justify-content-center
                          mx-auto
                          mt-auto
                          circle
                        "
                    :class="{
                      'd-md-flex': addedItems.includes(product.id),
                    }"
                    :disabled="loading"
                  >
                    <i class="far fa-minus"></i>
                  </button>

                  <span class="d-none mx-2" :class="{ 'd-md-block': addedItems.includes(product.id) }">
                    Qty: {{ basket?.items[product.id]?.quantity || 0 }}
                  </span>

                  <button
                    @click="addItem(product)"
                    class="
                          btn
                          align-items-center
                          justify-content-center
                          mx-auto
                          mt-auto
                          circle
                          d-flex
                        "
                    :class="{
                      /*'d-none': addedItems.includes(product.id),
                      'd-flex': !addedItems.includes(product.id),*/
                      'btn-primary': !addedItems.includes(product.id),
                      'btn-secondary': addedItems.includes(product.id),
                    }"
                    :disabled="loading"
                  >
                    <i class="far fa-plus"></i>
                  </button>

                  <button
                    v-if="!product.available"
                    class="
                          btn btn-primary
                          d-flex
                          align-items-center
                          justify-content-between
                          w-100
                          disabled
                        "
                    data-bs-toggle="tooltip"
                    data-placement="top"
                    :title="product.unavailability_reason"
                  >
                    Unavailable
                  </button>

                  <!-- Mobile quantity select to show when one is added -->
                  <div
                    v-if="basket && basket.items && addedItems.includes(product.id)"
                    class="d-md-none mt-auto select-wrapper position-relative"
                    :class="{ 'd-none': !addedItems.includes(product.id) }"
                  >
                    <select
                      :name="'mobile-qty-' + product.id"
                      :id="'mobile-qty-' + product.id"
                      class="form-control"
                      v-model="basket.items[product.id].quantity"
                      v-on:change="updateQuantities"
                    >
                      <option :value="0">Remove</option>
                      <option
                        v-for="option in quantitySelectOptions"
                        :value="option.value"
                        :key="'mobile-qty-' + product.id + '-' + option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>

                    <i class="far fa-chevron-down"></i>
                  </div>
                </div>

                <div v-if="addedItems.includes(product.id)" class="selected-label">
                  <span>Selected</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="alert alert-warning mt-4">
      No extras are currently available.
    </div>

    <div v-if="options" class="options-overlay position-fixed">
      <div class="content">
        <div @click="resetOptions()" class="d-flex justify-content-end mb-4">
          <i class="close-icon far fa-times"></i>
        </div>

        <h5 class="text-center">Great choice!</h5>
        <p class="text-center">There's just some options for you...</p>

        <div class="form-floating select-wrapper mb-3">
          <select v-model="selectedOption" name="options" id="options" class="form-control">
            <option :value="null">Options</option>
            <option
              v-for="product in options"
              :key="product.id"
              :value="product"
            >
              {{ product.name }} <span v-if="!hidePrices">- &pound;{{ product.price_inc_tax | money }}</span>
            </option>
          </select>

          <i class="far fa-chevron-down"></i>

          <label for="options">Options</label>
        </div>

        <button
          @click="addItem(selectedOption)"
          type="button"
          class="
            btn
            btn-primary
            btn-block
            w-100
            d-flex
            align-items-center
            justify-content-between
          "
          :disabled="!selectedOption"
          :title="!selectedOption ? 'You must first select an option.' : false"
        >
          Add to Basket <i class="far fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      options: null,
      selectedOption: null,
      selectedCategory: null,
      basket: null,
      backLink: window.backLink || null,
    };
  },

  props: {
    customisation: {
      type: Object,
      default: null,
    },
    productCategories: {
      type: Array,
      default: null,
    },
    products: {
      type: Object,
      default: null,
    },
    isPreRes: {
      type: Boolean,
      default: false,
    },
    hidePrices: {
      type: Boolean,
      default: false,
    },
    activeScreen: {
      type: Boolean,
      default: false,
    },
    rootBasket: {
      type: Object,
      default: null,
    },
    appUrl: {
      type: String,
      default: null,
    },
  },

  computed: {
    addedItems() {
      return !this.basket || !this.basket.items ? [] : Object.keys(this.basket.items).map((key) => parseInt(key));
    },

    nonEmptyProductCategories() {
      const nonEmptyProductCategories = this.productCategories.filter((category) => {
        return this.products[category.id] && Object.keys(this.products[category.id]).length > 0;
      });

      if (this.activeScreen) {
        // Prepend an "All" category to the beginning of the array.
        nonEmptyProductCategories.unshift({
          id: 0,
          name: "All",
        });

        // Add all products to the "All" category.
        this.$set(this.products, 0, {});

        for (let category of nonEmptyProductCategories) {
          if (category.id === 0) {
            continue;
          }

          for (let product of Object.values(this.products[category.id])) {
            this.$set(this.products[0], product.id, product);
          }
        }

        // Remove the "All" category if there's only one category.
        if (nonEmptyProductCategories.length === 2) {
          nonEmptyProductCategories.shift();
        }

        // Sort the "All" category by name.
        this.products[0] = Object.fromEntries(
          Object.entries(this.products[0]).sort((a, b) => {
            return a[1].name.localeCompare(b[1].name);
          })
        );
      }

      // Set the selected category if not already set.
      if (this.selectedCategory === null) {
        this.selectedCategory = nonEmptyProductCategories.length > 0 ? nonEmptyProductCategories[0].id : null;
      }

      return nonEmptyProductCategories;
    },

    allProductsCount() {
      let count = 0;
      for (let category in this.products) {
        count += Object.keys(this.products[category]).length;
      }
      return count;
    },

    // Generate an array of numbers from 1 to 100, prefixed with "Qty: "
    quantitySelectOptions() {
      return Array.from(Array(100).keys()).map((i) => {
        return {
          value: i + 1,
          label: `Qty: ${i + 1}`,
        };
      });
    },
  },

  watch: {
    rootBasket: function (newValue, oldValue) {
      if (newValue) {
        this.basket = newValue;
      }
    },
  },

  created() {
    this.$nextTick(function () {
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
      const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    });
  },

  methods: {
    resetOptions() {
      this.options = null;
      this.selectedOption = null;
      $("body").removeClass("modal-open");
    },

    addItem(product, quantity = 1) {
      // Is the product available?
      if (!product.available) {
        return;
      }

      // Is it a matrix item?
      if (product.type === "matrix") {
        this.options = product.children;
        $("body").addClass("modal-open");
        return;
      }

      // Is it an option?
      if (product.type === 'option') {
        this.resetOptions();
      }

      const items = [
        {
          product_id: product.id,
          quantity: quantity,
        },
      ];

      this.addItems(items);
    },

    addItems(items) {
      this.loading = true;

      axios
        .post(window.api_url + "/basket/add_items", {
          items: items,
        })
        .then((res) => {
          if (res.data && res.data.success) {
            this.$root.basket = res.data.basket;
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          this.loading = false;
        });
    },

    removeItem(item, quantity = 1) {
      this.loading = true;

      axios
        .post(window.api_url + "/basket/remove_items", {
          items: [
            {
              product_id: item.id,
              quantity: quantity,
            }
          ],
        })
        .then((res) => {
          if (res.data && res.data.success) {
            this.$root.basket = res.data.basket;
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          this.loading = false;
        });
    },

    vueBack() {
      window.history.back();
    },

    updateQuantities() {
      this.loading = true;

      const items = Object.keys(this.basket.items).map((key) => {
        return {
          product_id: parseInt(key),
          quantity: this.basket.items[key].quantity,
        };
      });

      axios
        .post(window.api_url + "/basket/update_quantities", {
          items: items,
        })
        .then((res) => {
          if (res.data && res.data.success) {
            this.$root.basket = res.data.basket;

            console.log(this.addedItems);
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
